import {
  faBookmark,
  faDollarSign,
  faLocationDot,
  faNoteSticky,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { JobPostedAge } from "sr/helpers/functions/JobPostedAge";
import { HTMLStringRender } from "sr/helpers/ui-components/HTMLStringRender";
import Job from "app/pages/component/types/Job";
import getLabelByValue from "sr/helpers/functions/getLabelByValue";
import { payTypes } from "sr/i18n/messages/setting";
import { formatNumberWithCommas } from "sr/helpers/functions/formatNumber";
interface ChildProps {
  jobs: Job;
  link: string;
  isSavedJobs?: boolean | null;
}

const JobItemCard: React.FC<ChildProps> = ({
  link,
  jobs,
  isSavedJobs = null,
}) => {
  const [postedDays, setpostedDays] = useState(null);
  useEffect(() => {
    setpostedDays(JobPostedAge(jobs?.createdAt));
  }, [jobs]);
  return (
    <Link to={link ? link : `/job-detail/${jobs?.id}`}>
      <div className="bg-white p-6 rounded-[20px] shadow-sm shadow-slate-300 w-full mb-5">
        <div>
          <div className="font-bold  text-lg">{jobs?.job_title}</div>
          <div className="lg:flex block items-center">
            {/* <span className='text-sm  font-bold'>{jobs?.companyname}</span> */}
            {/* {
                            isSavedJobs &&
                            <div className='items-center justify-items-start lg:justify-items-end grid grid-cols-2 divide-x divide-solid divide-slate-400'>
                                <div>
                                    <span className='px-2'>
                                        <FontAwesomeIcon icon={faStar} className='text-yellow-500 text-sm' />
                                        <span className='text-sm text-gray-500  font-bold'>3.5</span>
                                    </span>
                                </div>
                                <div className='text-sm text-gray-500  font-bold pl-[10px]'>
                                    729 <FormattedMessage id='CLEANER.JOBS.REVIEWS' defaultMessage='Reviews'></FormattedMessage>
                                </div>
                            </div>
                        } */}
          </div>
        </div>

        <div className="mt-4 grid lg:grid-cols-4 grid-cols-1 lg:divide-x text-sm">
          {/* Pricing */}
          <div className="px-4 py-2 flex items-center gap-2">
            <FontAwesomeIcon icon={faDollarSign} className="text-gray-500" />
            <span className="font-medium text-gray-800">
              {jobs?.show_pay_by === "Range"
                ? `${formatNumberWithCommas((jobs?.min_amount || 0).toFixed(2))} - ${formatNumberWithCommas((jobs?.max_amount || 0).toFixed(2))}`
                : jobs?.show_pay_by === "Starting amount"
                ? formatNumberWithCommas((jobs?.min_amount || 0).toFixed(2))
                : jobs?.show_pay_by === "Maximum amount"
                ? formatNumberWithCommas((jobs?.max_amount || 0).toFixed(2))
                : formatNumberWithCommas((jobs?.exact_amount || 0).toFixed(2))}{" "}
              <FormattedMessage
                id={getLabelByValue(jobs?.rate?.replace(/\s+/g, ""), payTypes)}
              />
            </span>
          </div>

          {/* Location */}
          {jobs?.job_advanced_id?.reporting_address && (
            <div className="px-4 py-2 flex items-center gap-2">
              <FontAwesomeIcon icon={faLocationDot} className="text-gray-500" />
              <span className="text-gray-700 truncate">
                {jobs?.job_advanced_id?.reporting_address?.city},{" "}
                {jobs?.job_advanced_id?.reporting_address?.state}
              </span>
            </div>
          )}

          {/* Openings */}
          <div className="px-4 py-2 flex items-center gap-1 text-sm">
            <span className="text-gray-500">Openings:</span>
            <span className="font-semibold text-gray-800">
              {jobs?.job_advanced_id?.hire_count || 1}
            </span>
          </div>

          {/* Applicants */}
          {jobs?.application_ids && (
            <div className="px-4 py-2 flex items-center gap-1 text-sm">
              <span className="text-gray-500">Applicants:</span>
              <span className="font-semibold text-gray-800">
                {jobs?.application_ids?.length || 0}
              </span>
            </div>
          )}
        </div>

        <div className="flex mt-2 items-center space-x-2">
          <FontAwesomeIcon icon={faNoteSticky} />
          <HTMLStringRender
            htmlContent={jobs?.job_description?.slice(0, 100)}
          ></HTMLStringRender>
          {jobs?.job_description?.length > 100 && "..."}
        </div>

        <div className="lg:mt-3 mt-5 flex items-center justify-between ">
          <div className="text-xs font-bold  text-gray-500">
            <FormattedMessage
              id="CLEANER.JOBS.TIME"
              defaultMessage="{DayNumber} Ago"
              values={{ DayNumber: postedDays }}
            />
          </div>
          <div>
            <Link
              to={`/job-detail/${jobs?.id}`}
              className="bg-[#ff39b3] font-bold hover:bg-navy text-white px-4 py-2 w-28 rounded-3xl"
            >
              <FormattedMessage
                id="CLEANER.JOBS.CARD.BUTTON"
                defaultMessage="Details"
              />
            </Link>
          </div>
        </div>
        <div className="flex justify-end mt-5 ">
          {isSavedJobs && (
            <button className="w-20 rounded-3xl flex justify-center items-center">
              <FontAwesomeIcon
                icon={faBookmark}
                className="mr-2"
              ></FontAwesomeIcon>
              <span className="font-bold  text-sm">
                {" "}
                <FormattedMessage
                  id="CLEANER.SAVEDJOBS.SAVED.TEXT"
                  defaultMessage="Saved"
                />{" "}
              </span>
            </button>
          )}
        </div>
      </div>
    </Link>
  );
};

export default JobItemCard;
